import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=076110f8&scoped=true&"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js&"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=076110f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076110f8",
  null
  
)

export default component.exports